/**
 * 前端分组规则
 * 用于判断 token 是否属于过程（Process）或参与者（Participant）
 * 这些规则补充后端的 in_gc / in_dx 标注
 */

import { TokenInfo } from '../types';

/**
 * 判断 token 是否是过程的一部分
 * 规则：
 * 1. 后端标注 in_gc = true 的 token
 * 2. there be 句型中的 "there"（dep=expl，head 是 be 动词）
 */
export function isProcessToken(token: TokenInfo, allTokens: TokenInfo[]): boolean {
  // 排除标点和空格
  if (token.pos === 'PUNCT' || token.pos === 'SPACE') return false;
  
  // 规则 1: 后端已标注为过程
  if (token.in_gc) return true;
  
  // 规则 2: there be 句型中的 there
  if (isThereInThereBe(token, allTokens)) return true;
  
  return false;
}

/**
 * 判断 token 是否是参与者的一部分
 * 规则：
 * 1. 后端标注 in_dx = true 的 token
 */
export function isParticipantToken(token: TokenInfo, _allTokens: TokenInfo[]): boolean {
  // 排除标点和空格
  if (token.pos === 'PUNCT' || token.pos === 'SPACE') return false;
  
  // 规则 1: 后端已标注为参与者
  if (token.in_dx) return true;
  
  return false;
}

// ============ 具体规则函数 ============

/**
 * 规则: there be 句型
 * 在 "there is/are/was/were" 中，there 和 be 动词一起构成过程
 * 判断条件：
 * - token.lemma = "there"
 * - token.dep = "expl" (存在句虚词)
 * - head 是 be 动词 (lemma = "be" 且 in_gc = true)
 */
function isThereInThereBe(token: TokenInfo, allTokens: TokenInfo[]): boolean {
  if (token.lemma?.toLowerCase() !== 'there') return false;
  if (token.dep !== 'expl') return false;
  
  // 查找 head token
  const headToken = allTokens.find(t => t.index_doc === token.head_i);
  if (!headToken) return false;
  
  // 检查 head 是否是 be 动词
  if (headToken.lemma?.toLowerCase() === 'be' && headToken.in_gc) {
    return true;
  }
  
  return false;
}

// ============ 可扩展区域：添加更多规则 ============

/**
 * 示例：如果需要添加新规则，可以：
 * 
 * 1. 创建规则函数：
 *    function isXxxPattern(token: TokenInfo, allTokens: TokenInfo[]): boolean {
 *      // 判断逻辑
 *      return false;
 *    }
 * 
 * 2. 在 isProcessToken 或 isParticipantToken 中添加调用：
 *    if (isXxxPattern(token, allTokens)) return true;
 */

